import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  additionalInfoHeader: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '3rem auto',
    textAlign: 'start',
    gap: '3rem',
  },
  fileUpload: {
    marginBottom: '8rem',
    textAlign: 'left',
  },
  subtitle: {
    paddingBottom: '2rem',
    borderBottom: `0.1rem solid ${colors.neutral[300]}`,
    display: 'flex',
    flexDirection: 'column',
    gap: '1.5rem',
    alignItems: 'center',
  },
  warningBlock: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '1.5rem',
    borderRadius: '0.6rem',
    background: colors.neutral[100],
  },
  warningMessage: {
    color: colors.neutral[900],
    fontSize: '1.6rem',
    lineHeight: '2.2rem',
    margin: 0,
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
